// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"rO","link":"rP","linkText":"rQ","linkIcon":"rR","isRental":"rS","active":"rT","synopsisAndButton":"rU","linkWrapper":"rV"};